// Do Not Change the keys, they are being used in the api calls
export enum PortalTypeEnum {
	SponsorPortal = 0,
	InternalPortal = 1,
	CandidatePortal = 2,
}
